import { CallStatus } from '@bandido/shared/constants';
import AudioWave from '@frontend/features/common/components/AudioWave';
import { PhoneInTalk, PhoneMissed } from '@mui/icons-material';
import { Box, Skeleton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  status: CallStatus | null;
  fileId?: number;
  isLoading: boolean;
  size: 'small' | 'medium';
};

const CallStatusIndicator = ({ status, fileId, isLoading, size }: Props) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <Skeleton variant="rectangular" width={size === 'small' ? 100 : 200} height={size === 'small' ? 100 : 200} />
    );
  }

  if (status === CallStatus.IN_PROGRESS) {
    return (
      <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
        <Typography color="success.main" variant="body2">
          {t(`calls.status.${CallStatus.IN_PROGRESS}`)}
        </Typography>
        <PhoneInTalk sx={{ color: 'success.main' }} />
      </Box>
    );
  }

  if (status === CallStatus.DECLINED) {
    return (
      <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
        <Typography color="error.main" variant="body2">
          {t(`calls.status.${CallStatus.DECLINED}`)}
        </Typography>
        <PhoneMissed sx={{ color: 'error.main' }} />
      </Box>
    );
  }

  if (status === CallStatus.COMPLETED && fileId) {
    return <AudioWave fileId={fileId} />;
  }

  return null;
};

export default CallStatusIndicator;
